import { GlobalMessages, TranslationGlobalMessages } from "@languages/interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.filtersText]: "Filters",
  [GlobalMessages.activeText]: "Active",
  [GlobalMessages.inactiveText]: "Inactive",
  [GlobalMessages.saveText]: "Save",
  [GlobalMessages.columnActions]: "Actions",
  [GlobalMessages.buttonAdd]: "Add new",
  [GlobalMessages.buttonDelete]: "Delete",
  [GlobalMessages.buttonRefresh]: "Refresh",
  [GlobalMessages.buttonCancel]: "Cancel",
  [GlobalMessages.buttonConfirm]: "Confirm",
  [GlobalMessages.entityUser]: "User",
  [GlobalMessages.yesText]: "Yes",
  [GlobalMessages.noText]: "No",
  [GlobalMessages.resetPasswordText]: "Reset Password",
  [GlobalMessages.logout]: "Logout",
  [GlobalMessages.editUser]: "Edit user",
  [GlobalMessages.invalidFormInputs]: "Fill in all required information of the current tab",
  [GlobalMessages.toastWarning]: "Warning",
  [GlobalMessages.errorText]: "Error",
  [GlobalMessages.warningTitleText]: "Warning",
  [GlobalMessages.selectAllText]: "Select all",
  [GlobalMessages.removeAllText]: "Remove all",
  [GlobalMessages.noRecordsFoundText]: "No records found",
  [GlobalMessages.loading]: "Loading...",
  [GlobalMessages.accessDenied]: "Access Denied",
  [GlobalMessages.insufficientPermissions]: "You don't have permission to perform this action"
};
